import React from 'react';
import { find } from 'lodash';
import { ActionMenu } from '@life-line-lab/components-react';

import './status-selector.scss';

interface Option {
  label: string;
  value: string;
  isDisable?: boolean;
  onClick: (event: MouseEvent) => void;
}

interface StatusSelectorProps {
  status: string;
  options: Option[];
  onVisibleChange?: (visible: boolean) => void;
}

const StatusSelector: React.FC<StatusSelectorProps> = ({ status, options, onVisibleChange }) => {
  const selectedStatus = find(options, (option) => { return option.value === status })

  return (
    <div className="status-selector">
      <ActionMenu
        label={
          <span className={`status ${selectedStatus!.value}`}>
            {selectedStatus!.label}
          </span>
        }
        actions={options}
        onVisibleChange={onVisibleChange}
      />
    </div>
  )
}

export default StatusSelector;
